import ToggleButton from "../fields/ToggleButton";
import { getProductColumns } from "@/lib/productVariants";
import styles from "./StepProduits.module.css";

interface StepProduitsProps {
  value: string[];
  products: string[];
  onChange: (value: string[]) => void;
}

const COLUMN_CLASS: Record<number, string> = {
  1: styles.cols1,
  2: styles.cols2,
  3: styles.cols3,
};

export default function StepProduits({
  value,
  products,
  onChange,
}: StepProduitsProps) {
  const toggleProduct = (product: string) => {
    if (value.includes(product)) {
      onChange(value.filter((p) => p !== product));
    } else {
      onChange([...value, product]);
    }
  };

  // Nombre pair de produits ⇒ 2 colonnes (lignes pleines), impair ⇒ 3 colonnes
  // comme la liste complète de 9. Cf. getProductColumns.
  const columnClass = COLUMN_CLASS[getProductColumns(products.length)];

  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.legend}>
        Pour quel(s) produit(s) souhaitez-vous un devis ?
      </legend>
      <div className={`${styles.grid} ${columnClass}`}>
        {products.map((product) => (
          <ToggleButton
            key={product}
            label={product}
            value={product}
            active={value.includes(product)}
            onClick={toggleProduct}
            type="checkbox"
            variant="product"
          />
        ))}
      </div>
    </fieldset>
  );
}
